module.exports = __webpack_public_path__ + "img/hatching.54bd8715.svg";